import styled from "styled-components";

export const GameplayContainerWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 29;
	overflow-y: auto;
	overflow-x: hidden;
	background: ${({ bgImage }) => bgImage && `url(${bgImage}) center top no-repeat`};
	background-size: ${({ bgSize }) => bgSize || "cover"};

	@media (min-width: 425px) {
		background-size: 768px 850px;
	}

	@media (min-width: 768px) {
		background-size: 1024px 840px;
	}

	@media (min-width: 1024px) {
		background-size: 1440px 560px;
	}

	@media (min-width: 1440px) {
		background-size: 1600px 770px;
	}

	@media (min-width: 1600px) {
		background-size: 2400px 800px;
	}
`;
